import { PayloadAction } from '@reduxjs/toolkit'
import { AnyAction, Dispatch, MiddlewareAPI, Reducer } from 'redux'
import { LocationState, RoutesMap } from 'redux-first-router'

import { FlagValues } from '~shared-components/components/FlagRender/useFlags'
import { syncRoutesMapUpdateAction } from '~shared-components/redux/actions/location.actions'
import { redirectToNotFound } from '~shared-components/utils/router'

import { SharedState } from '../sharedState'

const syncRoutesWithFeatureFlags = (
  routeMap: RoutesMap,
  featureFlags: Partial<FlagValues>,
  routesFlags: RoutesMap,
) =>
  Object.entries(routeMap).reduce(
    (acc, [key, value]) =>
      routesFlags[key] !== undefined &&
      featureFlags[routesFlags[key] as keyof RoutesMap] === false
        ? acc
        : { ...acc, [key]: value },
    {} as RoutesMap,
  )

export const extendLocationReducer = (
  routerReducer: Reducer<LocationState>,
) => (
  state: LocationState<{}, SharedState>,
  action: PayloadAction<RoutesMap>,
) => {
  const { payload, type } = action
  switch (type) {
    case 'SYNC_ROUTE_MAP_UPDATE': {
      return {
        ...state,
        routesMap: {
          ...payload, // new routesMap in the payload
        },
      }
    }
    default:
      return routerReducer(state, action)
  }
}

export const createSyncRoutesMiddleware = (routesMap: RoutesMap) => ({
  dispatch,
  getState,
}: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  const { payload, type } = action
  if (type === 'SYNC_ROUTE_MAP') {
    const { type: routeType } = getState().location

    const newRoutesMap = syncRoutesWithFeatureFlags(
      routesMap, // original full routes map here, not from the state
      payload.features,
      payload.dependencies,
    )
    dispatch(syncRoutesMapUpdateAction(newRoutesMap))
    // redirect if on disabled route right now
    if (newRoutesMap[routeType] === undefined) {
      redirectToNotFound(dispatch)
    }
  } else {
    return next(action)
  }
}
